import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableDate',
})
export class TableDatePipe implements PipeTransform {
  transform(value: any, part?: 'date' | 'time'): string {
    if (!value) return '';
    const date = new Date(value);

    const complete = (num: number) => (num < 10 ? `0${num}` : num);

    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    const dateStr = `${complete(day)}/${complete(month)}/${year}`;
    const timeStr = `${complete(hours)}:${complete(minutes)}:${complete(
      seconds
    )}`;

    if (part === 'date') return dateStr;
    if (part === 'time') return timeStr;

    return `${dateStr}, ${timeStr}`;
  }
}
